module.exports = __webpack_public_path__ + "media/widget.1f4b5586.mp4";